/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Paste_Events_CancelInputs */

const en_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Original Timing`)
};

const fr_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le minutage original`)
};

const de_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originale Zündung verwenden`)
};

const it_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la temporizzazione originale`)
};

const ru_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать исходное время`)
};

const es_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilice la sincronización original`)
};

const zh_cn2_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用原时序`)
};

const ja_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナルのタイミングを使用する`)
};

const hi_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल समय का उपयोग करें`)
};

const pt_pt2_shortcut_keys_paste_events_cancel = /** @type {(inputs: Shortcut_Keys_Paste_Events_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar a sincronização original`)
};

/**
* | output |
* | --- |
* | "Use Original Timing" |
*
* @param {Shortcut_Keys_Paste_Events_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_paste_events_cancel = /** @type {((inputs?: Shortcut_Keys_Paste_Events_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Paste_Events_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "de") return de_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "it") return it_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "ru") return ru_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "es") return es_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "ja") return ja_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "hi") return hi_shortcut_keys_paste_events_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_paste_events_cancel(inputs)
	return en_shortcut_keys_paste_events_cancel(inputs)
});